import React from "react";
import { useState, useEffect } from "react";
import { Star } from "lucide-react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Css/Testimonial.css";
const Testimonials = () => {
  const testimonials = [
    {
      name: "Rajesh Kumar",
      company: "Global Exports Ltd",
      content:
        "New Southern India Roadlines has been instrumental in our business growth. Their reliable service and professional approach make them our preferred logistics partner.",
      rating: 5,
    },
    {
      name: "Priya Sharma",
      company: "Tech Solutions Inc",
      content:
        "Exceptional service quality and timely deliveries. Their team goes above and beyond to ensure customer satisfaction.",
      rating: 5,
    },
    {
      name: "Mohammed Ali",
      company: "Fresh Foods Co",
      content:
        "Their refrigerated transport service is outstanding. We trust them completely with our temperature-sensitive shipments.",
      rating: 5,
    },
  ];

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    // Initialize state
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 1,

    centerPadding: "50px",
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  return (
    <section id="testimonials" className="py-20 bg-gray-50 testimonials">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Client Testimonials
          </h2>
          <p className="text-xl text-gray-600">
            What our valued customers say about us
          </p>
        </div>

        {isMobile ? (
          <Slider {...carouselSettings}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testiContent">
                <div>
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star
                        key={i}
                        className="h-5 w-5 text-yellow-400 fill-current"
                      />
                    ))}
                  </div>
                  <p className="text-gray-600 mb-4">{testimonial.content}</p>
                </div>
                <div className="border-t pt-4">
                  <p className="font-semibold text-gray-900">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-600">{testimonial.company}</p>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          // Render Grid Layout for Desktop
          <div className="grid grid-cols-3 gap-6 TestIcont">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="col-span-1 bg-white p-6 rounded-lg shadow-lg"
              >
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="h-5 w-5 text-yellow-400 fill-current"
                    />
                  ))}
                </div>
                <p className="text-gray-600 mb-4">{testimonial.content}</p>
                <div className="border-t pt-4">
                  <p className="font-semibold text-gray-900">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-600">{testimonial.company}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
